import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import EzControlledDropDowntWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import "./styles.css";
import Breadcrumb from "../../../../common/Breadcrumb";
import { useStyles } from "../style";
import {
  RateAdminBreadcrumb,
  RateTypeDD,
  basicDetail,
  columns,
  editMode,
  rateAdjustment,
  rateExtraDaily,
  rateExtraMonthly,
  rateExtraWeekend,
  rateExtraWeekly,
  statusDD,
} from "../CreateRateAdminExtraProductCharge/constant";
import { Box, Container, Grid } from "@mui/material";
import EzControlledInputWithFloatingLabel from "../../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import { generatePath, useNavigate } from "react-router-dom";
import { APP_URLS } from "../../../../utils/constant";
import EzControlledCalendarWithFloatingLabel from "../../../../common/EzForm/EzControlledCalendar/WithFloatingLabel";
import { getFormBaseValidationRule } from "../../../../utils/form/form-utils";
import { additionbaselor } from "../../../../utils/common";
import { formatDates, formatDatesHyphan } from "../../../../utils";
import { useParams } from "react-router-dom";
import EzControlledRadioButtonWithLabel from "../../../../common/EzForm/EzControlledRadioButton/WithLabel";
import { RadioButton } from "primereact/radiobutton";
import EzControlledMultiSelecttWithFloatingLabel from "../../../../common/EzForm/EzControlledMultiSelect/WithFloatingLabel";

const CreateRateAdminExtraProductChargeComponent = (props) => {
  const navigate = useNavigate();
  const {
    history,
    initCreateRateAdminExtraProductChargeScreen,
    createRateAdminExtraProductCharge,
    editRateAdminExtraProductCharge,
    isLoading,
    isRateAdminExtraProductChargeCreateSuccess,
    isRateAdminExtraProductChargeCreateError,
    shouldBlockNavigation,
    isRateAdminExtraProductChargeDetailSuccess,
    isRateAdminExtraProductChargeDetailError,
    isRateAdminExtraProductChargeEditSuccess,
    isEdit,
    isCopy,
    ExtraProductCategoryDD,
    vehicleCategoryDD,
    isView,
    formFieldValueMap,
  } = props;
  console.log("check props of compoemnt", props);
  const [fixedCostValue, setFixedCostValue] = useState("no");
  const [isFixedValue, setIsFixedValue] = useState("no");

  const handleRadio = (e) => {
    const { name, value } = e.target;
    if (name === "fixedCost") {
      setFixedCostValue(value);
    } else {
      setIsFixedValue(value);
    }
  };
  const classes = useStyles();

  const {
    control,
    formState: { errors, isDirty },
    watch,
    register,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      console.log("check value come or not", formFieldValueMap);
      return formFieldValueMap;
    }, [formFieldValueMap]),
  });
  const isFixed = watch("isFixed");
  const fixedCost = watch("fixedCost");
  const dailybaseRate = watch("dailybaseRate");
  const dailylor1st = watch("dailylor1st");
  const dailylor2nd = watch("dailylor2nd");
  const dailylor3rd = watch("dailylor3rd");
  const dailylor4th = watch("dailylor4th");
  const dailylor5th = watch("dailylor5th");
  const dailylor6th = watch("dailylor6th");

  const weekendbaseRate = watch("weekendbaseRate");
  const weekendlor1st = watch("weekendlor1st");
  const weekendlor2nd = watch("weekendlor2nd");
  const weekendlor3rd = watch("weekendlor3rd");
  const weekendlor4th = watch("weekendlor4th");
  const weekendlor5th = watch("weekendlor5th");
  const weekendlor6th = watch("weekendlor6th");

  const weeklybaseRate = watch("weeklybaseRate");
  const weeklylor1st = watch("weeklylor1st");
  const weeklylor2nd = watch("weeklylor2nd");
  const weeklylor3rd = watch("weeklylor3rd");
  const weeklylor4th = watch("weeklylor4th");

  const navigateToRateAdminExtraProductChargeScreen = () => {
    navigate(APP_URLS.RATEADMIN_EXTRAPRODUCTCHARGE.HOME);
  };
  useEffect(() => {
    if (
      isRateAdminExtraProductChargeCreateSuccess ||
      isRateAdminExtraProductChargeEditSuccess
    ) {
      reset();
    }
  }, [isRateAdminExtraProductChargeCreateSuccess, isRateAdminExtraProductChargeEditSuccess]);
  useEffect(() => {
    initCreateRateAdminExtraProductChargeScreen();
  }, []);

  useEffect(() => {
    if (isRateAdminExtraProductChargeDetailSuccess) {
      reset({
        ...formFieldValueMap,
      });
    }
  }, [isRateAdminExtraProductChargeDetailSuccess, formFieldValueMap]);

  useEffect(() => {
    setFixedCostValue(fixedCost == 0 ? "no" : "yes");
    setIsFixedValue(isFixed == 0 ? "no" : "yes");
  }, [fixedCost, isFixed]);

  useEffect(() => {
    if (!isRateAdminExtraProductChargeCreateSuccess && !isRateAdminExtraProductChargeEditSuccess) {
      shouldBlockNavigation(isDirty);
    }
  }, [isDirty, shouldBlockNavigation, isRateAdminExtraProductChargeCreateSuccess, isRateAdminExtraProductChargeEditSuccess]);
  
  const onSubmit = (data) => {
    console.log("CHA", data);
    let newData = data;
    newData["userId"] = localStorage.getItem("userId");

    let rateBaseDTO = [
      {
        fkRatePlanId: 1,
        id: (isEdit && !isCopy) ? data?.dailybaseId : null,
        rate: Number(data?.dailybaseRate) || 0,
        status: 0,
      },
      {
        fkRatePlanId: 2,
        id: (isEdit && !isCopy) ? data?.weekendbaseId : null,
        rate: Number(data?.weekendbaseRate) || 0,
        status: 0,
      },
      {
        fkRatePlanId: 3,
        id: (isEdit && !isCopy) ? data?.weeklybaseId : null,
        rate: Number(data?.weeklybaseRate) || 0,
        status: 0,
      },
      {
        fkRatePlanId: 4,
        id: (isEdit && !isCopy) ? data?.monthlybaseId : null,
        rate: Number(data?.monthlybaseRate) || 0,
        status: 0,
      },
    ];

    let rateExtraDayDTOS = [
      {
        fkRatePlanId: 1,
        id: (isEdit && !isCopy) ? (data?.dailyextraId ?? null) : null,
        rate: Number(data?.dailyextraRate) || 0,
        status: 0,
      },
      {
        fkRatePlanId: 2,
        id: (isEdit && !isCopy) ? (data?.weekendextraId ?? null) : null,
        rate: Number(data?.weekendextraRate) || 0,
        status: 0,
      },
      {
        fkRatePlanId: 3,
        id: (isEdit && !isCopy) ? (data?.weeklyextraId ?? null) : null,
        rate: Number(data?.weeklyextraRate) || 0,
        status: 0,
      },
      {
        fkRatePlanId: 4,
        id: (isEdit && !isCopy) ? (data?.monthlyextraId ?? null) : null,
        rate: Number(data?.monthlyextraRate) || 0,
        status: 0,
      },
    ];
    let rateExtraHourDTOS = [
      {
        fkRatePlanId: 1,
        id: (isEdit && !isCopy) ? data?.dailyhoursId : null,
        rate: Number(data?.dailyhoursRate) || 0,
        status: 0,
      },
      {
        fkRatePlanId: 2,
        id: (isEdit && !isCopy) ? data?.weekendhoursId : null,
        rate: Number(data?.weekendhoursRate) || 0,
        status: 0,
      },
      {
        fkRatePlanId: 3,
        id: (isEdit && !isCopy) ? data?.weeklyhoursId : null,
        rate: Number(data?.weeklyhoursRate) || 0,
        status: 0,
      },
      {
        fkRatePlanId: 4,
        id: (isEdit && !isCopy) ? data?.monthlyhoursId : null,
        rate: Number(data?.monthlyhoursRate) || 0,
        status: 0,
      },
    ];
    let rateLorAdjustmentDTOS = [
      {
        fkLorId: 1,
        id: (isEdit && !isCopy) ? data?.dailylor1stId : null,
        rate: Number(data?.dailylor1st) || 0,
        status: 0,
      },
      {
        fkLorId: 2,
        id: (isEdit && !isCopy) ? data?.dailylor2ndId : null,
        rate: Number(data?.dailylor2nd) || 0,
        status: 0,
      },
      {
        fkLorId: 3,
        id: (isEdit && !isCopy) ? data?.dailylor3rdId : null,
        rate: Number(data?.dailylor3rd) || 0,
        status: 0,
      },
      {
        fkLorId: 4,
        id: (isEdit && !isCopy) ? data?.dailylor4thId : null,
        rate: Number(data?.dailylor4th) || 0,
        status: 0,
      },
      {
        fkLorId: 5,
        id: (isEdit && !isCopy) ? data?.dailylor5thId : null,
        rate: Number(data?.dailylor5th) || 0,
        status: 0,
      },
      {
        fkLorId: 6,
        id: (isEdit && !isCopy) ? data?.dailylor6thId : null,
        rate: Number(data?.dailylor6th) || 0,
        status: 0,
      },
      {
        fkLorId: 7,
        id: (isEdit && !isCopy) ? data?.weekendlor1stId : null,
        rate: Number(data?.weekendlor1st) || 0,
        status: 0,
      },
      {
        fkLorId: 8,
        id: (isEdit && !isCopy) ? data?.weekendlor2ndId : null,
        rate: Number(data?.weekendlor2nd) || 0,
        status: 0,
      },
      {
        fkLorId: 9,
        id: (isEdit && !isCopy) ? data?.weekendlor3rdId : null,
        rate: Number(data?.weekendlor3rd) || 0,
        status: 0,
      },
      {
        fkLorId: 10,
        id: (isEdit && !isCopy) ? data?.weekendlor4thId : null,
        rate: Number(data?.weekendlor4th) || 0,
        status: 0,
      },
      {
        fkLorId: 11,
        id: (isEdit && !isCopy) ? data?.weekendlor5thId : null,
        rate: Number(data?.weekendlor5th) || 0,
        status: 0,
      },
      {
        fkLorId: 12,
        id: (isEdit && !isCopy) ? data?.weekendlor6thId : null,
        rate: Number(data?.weekendlor6th) || 0,
        status: 0,
      },

      {
        fkLorId: 13,
        id: (isEdit && !isCopy) ? data?.weeklylor1stId : null,
        rate: Number(data?.weeklylor1st) || 0,
        status: 0,
      },
      {
        fkLorId: 14,
        id: (isEdit && !isCopy) ? data?.weeklylor2ndId : null,
        rate: Number(data?.weeklylor2nd) || 0,
        status: 0,
      },
      {
        fkLorId: 15,
        id: (isEdit && !isCopy) ? data?.weeklylor3rdId : null,
        rate: Number(data?.weeklylor3rd) || 0,
        status: 0,
      },
      {
        fkLorId: 16,
        id: (isEdit && !isCopy) ? data?.weeklylor4thId : null,
        rate: Number(data?.weeklylor4th) || 0,
        status: 0,
      },
    ];

    let stringifiedData = {
      id: (isEdit && !isCopy) ? data?.id : null,
      status: data?.status,
      title: data?.title,
      startDate: formatDatesHyphan(data?.startDate),
      endDate: formatDatesHyphan(data?.endDate),
      description: data?.description,
      fkExtracategoryId: data?.fkExtracategoryId,
      vehicleCategoryId: data?.vehicleCategoryId,
      fixedCost: data?.fixedCost || 0,
      isFixed: isFixedValue === "yes" ? 1 : 0,
      userId: localStorage.getItem("userId"),
    };
    if (fixedCostValue === "no" && isFixedValue === "no") {
      stringifiedData = {
        id: (isEdit && !isCopy) ? data?.id : null,
        status: data?.status,
        title: data?.title,
        startDate: formatDatesHyphan(data?.startDate),
        endDate: formatDatesHyphan(data?.endDate),
        description: data?.description,
        fkExtracategoryId: data?.fkExtracategoryId,
        vehicleCategoryId: data?.vehicleCategoryId,
        fixedCost: data?.fixedCost || 0,
        isFixed: isFixedValue === "yes" ? 1 : 0,
        userId: localStorage.getItem("userId"),
        rateBaseDTO: rateBaseDTO,
        rateExtraDayDTOS: rateExtraDayDTOS,
        rateExtraHourDTOS: rateExtraHourDTOS,
        rateLorAdjustmentDTOS: rateLorAdjustmentDTOS,
      };
    }
    (isEdit && !isCopy)
      ? editRateAdminExtraProductCharge({ id: data.id, data: stringifiedData })
      : createRateAdminExtraProductCharge(stringifiedData);
  };
  const getToastProps = () => {
    const toastTitle = "Please select category from list";
    return {
      severity: TOAST_SEVERITY.ERROR,
      toastTitle,
      shouldShowToast: false,
    };
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">
              {isEdit && !isCopy
                ? "Update Extra Product Charge"
                : isCopy
                ? "Copy Extra Product Charge"
                : "Create Extra Product Charge"}
            </h4>
          </div>
          <div className="buttonarea">
            <Button
              tooltip={"Back to Extra Product Charge"}
              tooltipOptions={{ position: "left" }}
              // label={"Back to Extra Product Charge"}
              icon={"pi pi-arrow-left"}
              className={`p-button `}
              style={{ borderRadius: "10px", marginBottom: "20px" }}
              onClick={navigateToRateAdminExtraProductChargeScreen}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container maxWidth="lg">
      <Breadcrumb list={RateAdminBreadcrumb} />
      <EzToast {...getToastProps()} />
      <div className={`containerbox ${classes.bg}`}>
        {renderPageHeaderSection()}
        <div className="form-demo">
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <Grid container spacing={2}>
              {basicDetail?.map((item) =>
                item.name === "status" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={statusDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "fkExtracategoryId" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={ExtraProductCategoryDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "vehicleCategoryId" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledMultiSelecttWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={vehicleCategoryDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.type === "date" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledCalendarWithFloatingLabel
                      id={item.name}
                      name={item.name}
                      {...register(item.name)}
                      showTime={false}
                      maxDate={new Date(2090, 0, 1)}
                      dateFormat="yy/mm/dd"
                      control={control}
                      isError={errors[item.name]}
                      errorMsg={getFormErrorMessage(item.name)}
                      label={item.label}
                      rules={
                        getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE
                      }
                    />
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ),
              )}
            </Grid>
            <Grid container xs={12} mb={"20px"}>
              <Grid item xs={6} sm={6}>
                Is this extra product included at no charge in the cost of
                rental?
              </Grid>
              <Grid item xs={6} sm={6} alignItems={"center"}>
                <input
                  checked={fixedCostValue === "yes"}
                  type="radio"
                  onChange={handleRadio}
                  name="fixedCost"
                  value="yes"
                />{" "}
                Yes
                <input
                  checked={fixedCostValue === "no"}
                  type="radio"
                  onChange={handleRadio}
                  name="fixedCost"
                  value="no"
                />{" "}
                No
              </Grid>
            </Grid>
            {(fixedCostValue !== "yes" || isEdit) && (
              <div>
                <Grid container xs={12} mb={"20px"}>
                  <Grid item xs={6} sm={6}>
                    Does this extra product have a fixed price?
                  </Grid>
                  <Grid item xs={6} sm={6} alignItems={"center"}>
                    <input
                      checked={isFixedValue === "yes"}
                      type="radio"
                      onChange={handleRadio}
                      name="isFixed"
                      value="yes"
                    />{" "}
                    Yes
                    <input
                      checked={isFixedValue === "no"}
                      type="radio"
                      onChange={handleRadio}
                      name="isFixed"
                      value="no"
                    />{" "}
                    No
                  </Grid>
                </Grid>
                {(isFixedValue === "yes" ) && (
                  <Grid container xs={12} mb={"20px"}>
                    <Grid item xs={6} sm={6}>
                      Fixed Cost
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <EzControlledInputWithFloatingLabel
                        name="fixedCost"
                        control={control}
                        type="number"
                        rules={{ required: false }}
                        isError={errors["fixedCost"]}
                        errorMsg={getFormErrorMessage("fixedCost")}
                      />
                    </Grid>
                  </Grid>
                )}
                {isFixedValue !== "yes" && (
                  <Grid>
                    <div className="table-responsive">
                      <table className="tablerate">
                        <tr>
                          <th>Rate</th>
                          <th>Base</th>
                          <th>Extra Day </th>
                          <th>Hour</th>
                          <th colSpan={"6"}>LOR Adjustments</th>
                        </tr>
                        <tr>
                          <td>Plan</td>
                          <td>Rate</td>
                          <td>Rate</td>
                          <td>Rate</td>
                          <td>1st</td>
                          <td>2nd</td>
                          <td>3rd</td>
                          <td>4th</td>
                          <td>5th</td>
                          <td>6th</td>
                        </tr>
                        <tr>
                          {rateExtraDaily?.map((item) =>
                            item.name !== undefined ? (
                              <td>
                                <EzControlledInputWithFloatingLabel
                                  name={item?.name}
                                  control={control}
                                  //label={item?.label}
                                  type={item?.type}
                                  rules={item?.rule}
                                  isError={errors[item?.name]}
                                  errorMsg={getFormErrorMessage(item?.name)}
                                />
                                {item.notify !== undefined ? (
                                  <span className="red">{item.notify}</span>
                                ) : (
                                  ""
                                )}

                                {item.name === "dailylor1st" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      dailybaseRate,
                                      dailylor1st,
                                    )}
                                  </span>
                                ) : item.name === "dailylor2nd" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      dailybaseRate,
                                      dailylor2nd,
                                    )}
                                  </span>
                                ) : item.name === "dailylor3rd" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      dailybaseRate,
                                      dailylor3rd,
                                    )}
                                  </span>
                                ) : item.name === "dailylor4th" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      dailybaseRate,
                                      dailylor4th,
                                    )}
                                  </span>
                                ) : item.name === "dailylor5th" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      dailybaseRate,
                                      dailylor5th,
                                    )}
                                  </span>
                                ) : item.name === "dailylor6th" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      dailybaseRate,
                                      dailylor6th,
                                    )}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </td>
                            ) : (
                              <td>{item.label}</td>
                            ),
                          )}
                        </tr>

                        <tr>
                          {rateExtraWeekend?.map((item) =>
                            item.name !== undefined ? (
                              <td>
                                <EzControlledInputWithFloatingLabel
                                  name={item?.name}
                                  control={control}
                                  //label={item?.label}
                                  type={item?.type}
                                  rules={item?.rule}
                                  isError={errors[item?.name]}
                                  errorMsg={getFormErrorMessage(item?.name)}
                                />
                                {item.notify !== undefined ? (
                                  <span className="red">{item.notify}</span>
                                ) : (
                                  ""
                                )}

                                {item.name === "weekendlor1st" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      weekendbaseRate,
                                      weekendlor1st,
                                    )}
                                  </span>
                                ) : item.name === "weekendlor2nd" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      weekendbaseRate,
                                      weekendlor2nd,
                                    )}
                                  </span>
                                ) : item.name === "weekendlor3rd" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      weekendbaseRate,
                                      weekendlor3rd,
                                    )}
                                  </span>
                                ) : item.name === "weekendlor4th" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      weekendbaseRate,
                                      weekendlor4th,
                                    )}
                                  </span>
                                ) : item.name === "weekendlor5th" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      weekendbaseRate,
                                      weekendlor5th,
                                    )}
                                  </span>
                                ) : item.name === "weekendlor6th" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      weekendbaseRate,
                                      weekendlor6th,
                                    )}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </td>
                            ) : (
                              <td>{item.label}</td>
                            ),
                          )}
                        </tr>
                        <tr>
                          {rateExtraWeekly?.map((item) =>
                            item.name !== undefined ? (
                              <td>
                                <EzControlledInputWithFloatingLabel
                                  name={item?.name}
                                  control={control}
                                  //label={item?.label}
                                  type={item?.type}
                                  rules={item?.rule}
                                  isError={errors[item?.name]}
                                  errorMsg={getFormErrorMessage(item?.name)}
                                />

                                {item.notify !== undefined ? (
                                  <span className="red">{item.notify}</span>
                                ) : (
                                  ""
                                )}

                                {item.name === "weeklylor1st" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      weeklybaseRate,
                                      weeklylor1st,
                                    )}
                                  </span>
                                ) : item.name === "weeklylor2nd" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      weeklybaseRate,
                                      weeklylor2nd,
                                    )}
                                  </span>
                                ) : item.name === "weeklylor3rd" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      weeklybaseRate,
                                      weeklylor3rd,
                                    )}
                                  </span>
                                ) : item.name === "weeklylor4th" ? (
                                  <span className="red">
                                    {additionbaselor(
                                      weeklybaseRate,
                                      weeklylor4th,
                                    )}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </td>
                            ) : (
                              <td>{item.label}</td>
                            ),
                          )}
                        </tr>
                        <tr>
                          {rateExtraMonthly?.map((item) =>
                            item.name !== undefined ? (
                              <td>
                                <EzControlledInputWithFloatingLabel
                                  name={item?.name}
                                  control={control}
                                  //label={item?.label}
                                  type={item?.type}
                                  rules={item?.rule}
                                  isError={errors[item?.name]}
                                  errorMsg={getFormErrorMessage(item?.name)}
                                />
                              </td>
                            ) : (
                              <td>{item.label}</td>
                            ),
                          )}
                        </tr>
                      </table>
                    </div>
                  </Grid>
                )}
              </div>
            )}
            <div className={"make-flex mt-3 mr-2"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                }}
              >
                <React.Fragment>
                  <div
                    style={{ margin: "15px 0px 15px 10px", minWidth: "100px" }}
                  >
                    <Button
                      type="submit"
                      label={isEdit ? "Update" : "Save"}
                      className="mt-2 p-button-raised"
                    />
                  </div>
                </React.Fragment>
              </div>
            </div>
            {isEdit && (
              <Grid className="modsection" container spacing={2}>
                {editMode?.map((item) => (
                  <Grid item xs={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      disabled={item?.disabled}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </form>
        </div>
      </div>
      <div></div>
    </Container>
  );
};

export default CreateRateAdminExtraProductChargeComponent;
